import { render } from "./TextEditorTooltip.vue?vue&type=template&id=17403ec4&scoped=true"
import script from "./TextEditorTooltip.vue?vue&type=script&lang=js"
export * from "./TextEditorTooltip.vue?vue&type=script&lang=js"

import "./TextEditorTooltip.vue?vue&type=style&index=0&id=17403ec4&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17403ec4"]])

export default __exports__